(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/components/app.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/components/app.js');
"use strict";


const {
  useCallback,
  useEffect,
  useState
} = React;
const {
  Filter,
  Matchlist,
  Navigation
} = svs.tt.components;
const {
  useDraws,
  useSportFilter
} = svs.tt.hooks;
const baseUrl = svs.core.data.baseUrl || '';
const settings = svs.tt.productSettings;
const parseProductKey = () => {
  const matchlistIndex = window.location.pathname.indexOf('/matchlist');
  if (matchlistIndex === -1) {
    return null;
  }
  const rest = window.location.pathname.slice(matchlistIndex + '/matchlist'.length);
  if (!rest || rest === '/') {
    return null;
  }
  return rest.replace(/^\//, '').replace(/\/.*$/, '') || null;
};
const buildMatchlistUrl = productKey => {
  const suffix = productKey ? "matchlist/".concat(productKey) : 'matchlist';
  return baseUrl.endsWith('/') ? "".concat(baseUrl).concat(suffix) : "".concat(baseUrl, "/").concat(suffix);
};
const resolveProductSetting = productKey => {
  if (productKey && settings[productKey]) {
    return {
      key: productKey,
      setting: settings[productKey]
    };
  }
  const fallback = svs.tt.defaultProduct;
  return {
    key: fallback,
    setting: settings[fallback]
  };
};
const App = () => {
  const [productKey, setProductKey] = useState(() => {
    const initial = parseProductKey();
    return resolveProductSetting(initial).key;
  });
  useEffect(() => {
    const onPopState = () => {
      const next = resolveProductSetting(parseProductKey()).key;
      setProductKey(next);
    };
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);
  const {
    setting: productSetting
  } = resolveProductSetting(productKey);
  const {
    draws,
    availableSports,
    loading
  } = useDraws(productSetting);
  const {
    filters,
    toggleSport,
    isVisible
  } = useSportFilter(productSetting);
  const onSelect = useCallback(nextKey => {
    if (!svs.tt.productSettings[nextKey] || nextKey === productKey) {
      return;
    }
    window.history.pushState({}, '', buildMatchlistUrl(nextKey));
    setProductKey(nextKey);
  }, [productKey]);
  const showMatchlist = !loading && productSetting && productSetting.productType !== 'start';
  return React.createElement("div", {
    className: "tt-container"
  }, React.createElement("div", {
    className: "tt-sidebar"
  }, React.createElement("div", {
    className: "tt-navigation"
  }, React.createElement(Navigation, {
    activeKey: productKey,
    onSelect: onSelect,
    productSettings: svs.tt.productSettings
  })), React.createElement("div", {
    className: "tt-filter"
  }, React.createElement(Filter, {
    availableSports: availableSports,
    filters: filters,
    onToggleSport: toggleSport,
    productSetting: productSetting
  }))), React.createElement("main", {
    "aria-labelledby": "main-heading",
    className: "tt-main"
  }, loading && React.createElement("p", {
    className: "padding-1"
  }, "Laddar..."), showMatchlist && React.createElement(Matchlist, {
    draws: draws,
    isVisible: isVisible,
    productSetting: productSetting
  })));
};
setGlobal('svs.tt.components.App', App);

 })(window);